import DetailJson from "@/views/components/detailJson";

/** 注册赠送会员配置详情，保持旧 Vue 的四个字段展示。 */
export default function DetailPanel({ businessConfig = {} }: { businessConfig?: Record<string, any> }) {
    return (
        <DetailJson
            data={businessConfig}
            columns={[
                {
                    list: [
                        {
                            label: "是否开启",
                            span: 4,
                            value: () =>
                                businessConfig.hasOpen === 1 ? "是" : businessConfig.hasOpen === 0 ? "否" : "--"
                        },
                        {
                            label: "赠送等级",
                            value: () =>
                                businessConfig.level === 2
                                    ? "\u200b基础会员"
                                    : businessConfig.level === 3
                                      ? "\u200b高级会员"
                                      : "--"
                        },
                        {
                            label: "赠送时长",
                            value: () => (businessConfig.duration ? `${businessConfig.duration}天` : "--")
                        },
                        {
                            label: "兑换有效期",
                            value: () =>
                                businessConfig.effectiveDuration ? `${businessConfig.effectiveDuration}天` : "--"
                        }
                    ]
                }
            ]}
        />
    );
}
